//import Libraries
import React, { Component } from 'react'
import { connect } from 'react-redux';

import {TabContent, TabPane, Nav, NavItem, NavLink} from 'reactstrap'
import classnames from 'classnames';

//import Components

import Loading from '../../components/Loading/Loading';
import AdminNav from './AdminNav/AdminNav';

import OrderManager from './OrderManager/OrderManager';
import ProductManager from './ProductManager/ProductManager';
import HomepageManager from './HomepageManager/HomepageManager';
import AccountManager from './AccountManager/AccountManager';
import ContactManager from './ContactManager/ContactManager';

import language from '../../language/language.json';

import * as adminActions from './actions/adminActions';

//import Styles
import 'bootstrap/dist/css/bootstrap.css'

class Admin extends Component{
    constructor(props){
        super(props);
        this.state = {
            active : '1' 
        }
    }

    componentDidMount() {
        this.props.onLoadProducts();
        this.props.onLoadCategory();
        this.props.onLoadOrders();
        this.props.onLoadAccounts(); 
        this.props.onLoadHistories();
        this.props.onLoadArticles();
        this.props.onLoadContacts();
        this.props.onLoadMains();
        this.props.onLoadIntroductions();
        this.props.onLoadCases();

        this.props.onLoadConstructions();
        // this.props.onLoadMaterials();
        this.props.onLoadFertilizers();
        this.props.onLoadMediums();
        this.props.onLoadExtras();
        this.props.onLoadCards();
    }

    toggle = (active) => {
        if(this.state.active !== active){
            this.setState({
                active 
            })
        }
    }

    render(){
        let content = {
            0 : <OrderManager />,
            1 : <ProductManager />,
            2 : <HomepageManager />,
            3 : <AccountManager />,
            4 : <ContactManager />
        }
        const { products , category , orders , accounts, histories, articles, contacts, mains, introductions, cases, 
                constructions, fertilizers, mediums, extras, cards  } = this.props; 
        if(!products || 
            !category ||
            !orders || 
            !accounts || 
            !histories ||
            !articles ||
            !contacts ||
            !mains ||
            !introductions ||
            !cases ||
            !constructions || 
            // !materials || 
            !fertilizers || 
            !mediums || 
            !extras || 
            !cards ) {
                content = {
                    0 : null,
                    1 : null,
                    2 : null,
                    3 : null,
                    4 : null 
                }
        }

        const tab = language["admintab"];

        return(
            <div>
                <AdminNav />
                <div className="NavWrapper">
                    <Nav className="TabWrapper" tabs>
                        <NavItem>
                            <NavLink
                                    className={classnames({active : this.state.active === '1'})}
                                    onClick={() => this.toggle('1')}
                            >
                                    주문관리
                            </NavLink>
                        </NavItem> 
                        <NavItem>
                            <NavLink
                                    className={classnames({active : this.state.active === '2'})}
                                    onClick={() => this.toggle('2')}
                            >
                                    상품관리
                            </NavLink>
                        </NavItem> 
                        <NavItem>
                            <NavLink
                                    className={classnames({active : this.state.active === '3'})}
                                    onClick={() => this.toggle('3')}
                            >
                                    홈페이지관리
                            </NavLink>
                        </NavItem> 
                        <NavItem>
                            <NavLink
                                    className={classnames({active : this.state.active === '4'})}
                                    onClick={() => this.toggle('4')}
                            >
                                    회원관리
                            </NavLink>
                        </NavItem> 
                        <NavItem>
                            <NavLink
                                    className={classnames({active : this.state.active === '5'})}
                                    onClick={() => this.toggle('5')}
                            >
                                    연락관리
                            </NavLink>
                        </NavItem> 
                    </Nav>
                </div>
                <TabContent activeTab={this.state.active}>
                    <TabPane tabId="1">
                        { content[0] }
                    </TabPane>
                    <TabPane tabId="2">
                        { content[1] }
                    </TabPane>
                    <TabPane tabId="3">
                        { content[2] }
                    </TabPane>
                    <TabPane tabId="4">
                        { content[3] }
                    </TabPane>
                    <TabPane tabId="5">
                        { content[4] }
                    </TabPane>

                </TabContent>
            </div>
        );
    }
}

const mapStateToProps = (state)=> {
    return {
        universal : state.universal,
        products : state.products,
        category : state.category,
        orders : state.orders,
        accounts : state.accounts,
        histories : state.admin.homepage.histories,
        articles : state.admin.homepage.articles,
        mains : state.admin.homepage.mains,
        introductions : state.admin.homepage.introductions,
        cases : state.admin.homepage.cases,

        constructions : state.admin.homepage.constructions,
        // materials : state.admin.homepage.materials ,
        fertilizers : state.admin.homepage.fertilizers,
        mediums : state.admin.homepage.mediums,
        extras : state.admin.homepage.extras,
        cards : state.admin.homepage.cards,

        contacts : state.admin.contact.contacts,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onLoadProducts : () => {
            dispatch(adminActions.loadProducts());
        },
        onLoadCategory : () => {
            dispatch(adminActions.loadCategory());
        },
        onLoadOrders : () => {
            dispatch(adminActions.loadOrders());
        },
        onLoadAccounts : () => {
            dispatch(adminActions.loadAccounts());
        },
        onLoadHistories : () => {
            dispatch(adminActions.loadHistories());
        },
        onLoadArticles : () => {
            dispatch(adminActions.loadArticles());
        },
        onLoadContacts : () => {
            dispatch(adminActions.loadContacts());
        },
        onLoadMains : () => {
            dispatch(adminActions.loadMains());
        },
        onLoadIntroductions : () => {
            dispatch(adminActions.loadIntroductions());
        },
        onLoadCases : () => {
            dispatch(adminActions.loadCases());
        },
        onLoadConstructions : () => {
            dispatch(adminActions.loadConstructions());
        },
        // onLoadMaterials : () => {
        //     dispatch(adminActions.loadMaterials());
        // },
        onLoadFertilizers : () => {
            dispatch(adminActions.loadFertilizers());
        },
        onLoadMediums : () => {
            dispatch(adminActions.loadMediums());
        },
        onLoadExtras : () => {
            dispatch(adminActions.loadExtras());
        },
        onLoadCards : () => {
            dispatch(adminActions.loadDepartmentsCards());
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Admin);


// WEBPACK FOOTER //
// ./src/pages/Admin/Admin.js